export class AcademicDetails{
    classId : number;
    sectionId: number;
    rollNumber?: number;
    educationalProgramId?: number;
    schoolId: number;
    academicYearId: number;
    academicProgramId: number;
}